import { render, staticRenderFns } from "./ThemeSelection.vue?vue&type=template&id=a76ce96e&lang=pug"
import script from "./ThemeSelection.vue?vue&type=script&lang=js"
export * from "./ThemeSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports